import { createLoader, parseAsInteger, parseAsString } from "nuqs/server";

import { filterParsers } from "../../hooks/filterParsers";
import { DEFAULT_CATALOG_SORT } from "../../types/catalog.type";
import type { ActiveCatalogFilters } from "../../types/filters.type";

export const getCatalogParams = createLoader({
  page: parseAsInteger.withDefault(1),
  sort: parseAsString.withDefault(DEFAULT_CATALOG_SORT),
});

export const getCatalogFilterParams = createLoader(filterParsers);

export function getActiveCatalogFilters(
  searchParams: Record<string, string | string[] | undefined>,
): ActiveCatalogFilters | undefined {
  const entries = Object.entries(getCatalogFilterParams(searchParams)).filter(
    ([, value]) => value !== null,
  );

  return entries.length > 0
    ? (Object.fromEntries(entries) as ActiveCatalogFilters)
    : undefined;
}
